import { useSelector } from "react-redux";
import React from "react";

import { Link } from "react-router-dom";

import useStyles from "components/app/Styles";
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Grid,
  Typography,
  useMediaQuery,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import appActions from "../actions";
// import HeaderView from "./HeaderView";
import { USER_PROP } from "components/User/constants";
import {
  desktopUserSettings,
  mobileUserSettings,
  userSettings,
  appLinks,
} from "../constants";
import { getAuthorizedRoutes } from "../Validations";

const SideBar = () => {
  const { drawer } = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.settings.profile);
  const { setDrawerState } = appActions();
  const classes = useStyles();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const { location } = useSelector((state) => state.router);
  const isSettingsScreen = () => {
    return (
      userSettings.findIndex((item) => item.route === location.pathname) !== -1
    );
  };
  const { loggedIn, role } = useSelector((state) => state.auth);

  const showAppLinks = () => (matches ? !isSettingsScreen() : true);
  const showSettings = () => (matches ? isSettingsScreen() : true);

  return (
    <Drawer
      variant={matches ? "permanent" : "temporary"}
      className={classes.drawer}
      anchor={matches ? "left" : "right"}
      open={drawer}
      onClose={() => setDrawerState()}
      classes={matches ? {} : { paper: classes.drawerPaper }}
    >
      <Box direction="column" className={matches ? classes.drawerContent : ""}>
        {matches ? (
          <Box></Box>
        ) : (
          // <Box className={classes.sidebarLogo}>{/* <HeaderView />{" "} */}</Box>
          <Box p={4}>
            <Grid
              container
              direction="column"
              justify="flex-start"
              alignContent="flex-start"
            >
              <Avatar alt="Logo" className={classes.AvatarSmall}>
                {(user[USER_PROP.FNAME].toUpperCase()[0] || "") +
                  (user[USER_PROP.LNAME].toUpperCase()[0] || "")}
              </Avatar>
              <Typography variant="h6" gutterBottom>
                {`${user[USER_PROP.FNAME]} ${user[USER_PROP.LNAME]}`}
              </Typography>
            </Grid>
          </Box>
        )}
        {/* <Divider /> */}
        <div
          role="presentation"
          onClick={() => setDrawerState()}
          onKeyDown={() => setDrawerState()}
          className={matches ? classes.sidebarList : classes.sidebarListM}
        >
          <List disablePadding>
            {showAppLinks() &&
              appLinks.map((link) => (
                <ListItem
                  selected={location.pathname === link.route}
                  button
                  key={link.route}
                  component={Link}
                  to={link.route}
                >
                  <ListItemText
                    className={classes.navBarList}
                    primary={link.text}
                    classes={{ primary: classes.drawerText }}
                  />
                </ListItem>
              ))}
            {!matches && <Divider />}
            {showSettings() &&
              (matches
                ? getAuthorizedRoutes(desktopUserSettings, loggedIn, role)
                : getAuthorizedRoutes(mobileUserSettings, loggedIn, role)
              ).map((link) => (
                <ListItem
                  selected={location.pathname === link.route}
                  button
                  key={link.route}
                  component={Link}
                  to={link.route}
                >
                  <ListItemText
                    className={classes.navBarList}
                    primary={link.text}
                    classes={{ primary: classes.drawerText }}
                  />
                </ListItem>
              ))}
          </List>
        </div>
      </Box>
    </Drawer>
  );
};

export default SideBar;
